module.exports = __webpack_public_path__ + "com_index_01bg.jpg?6cf77e1746249a4b4e33465a335cc74c";


//////////////////
// WEBPACK FOOTER
// ./static/images/com_index_01bg.jpg
// module id = 307
// module chunks = 0